// @flow

export default class LegalEntity {
  id: string;
  email: string;
  business_name: string;
  rfc: string;
  is_disabled: boolean;
  address: {
    street: string,
    neighborhood: string,
    ext_number: string,
    int_number: string,
    town: string,
    state: string,
    district: string,
    country: string,
    zip: string
  };

  constructor(data: any = {}) {
    this.id = data.id || undefined;
    this.email = data.email || '';
    this.business_name = data.business_name || '';
    this.rfc = data.rfc || '';
    this.is_disabled = data.is_disabled || false;
    const address = data.address;
    this.address = {
      street: address && address.street ? address.street : '',
      neighborhood: address && address.neighborhood ? address.neighborhood : '',
      ext_number: address && address.ext_number ? address.ext_number : '',
      int_number: address && address.int_number ? address.int_number : '',
      town: address && address.town ? address.town : '',
      state: address && address.state ? address.state : '',
      district: address && address.district ? address.district : '',
      country: address && address.country ? address.country : '',
      zip: address && address.zip ? address.zip : ''
    }
  }
  
  get isReadyForBilling() {
    return this.email && this.business_name && this.rfc &&
      this.address.street && this.address.neighborhood &&
      this.address.ext_number && this.address.int_number &&
      this.address.district && this.address.town &&
      this.address.state && this.address.country && this.address.zip
  }
}
